export default {
    CANCELLED_RESPONSE_CODE: 'CANCELLED',
    ENDPOINT: '/api/',
    HEADERS: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': typeof document !== 'undefined' ? document.head.querySelector('meta[name="csrf-token"]').content : '',
    },
    TIMEOUT: 120000,
};
